/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import CardLayout from "../Cards/CardLayout";

import Loader from "../feedBacks/loader";
import NoContent from "../feedBacks/NoContent";
import CardError from "../feedBacks/CardError";
import SingleTable from "./SingleTable";
import { IHierarchicalNode } from "../../utils/interfaces";
import { useUtils } from "../../customHooks/useUtils";

function LevelDetailTable({
  isLoading,
  error,
  data,
}: {
  isLoading: boolean;
  error: string;
  data: IHierarchicalNode;
}) {
 const { t } = useUtils();
  // Transform the data for the SiteDetailsTable format
  const detailsData = data
    ? {
        [t("name")]: data.name,
        [t("belong_to")]:
          data.parent && data.parent.length
            ? `${data.parent.map((parent: any) => parent.name).join(", ")}`
            : "N/A",
        [t("num_power_assets")]: data.devices && data.devices.length,
        // [t("site_details.state")]: data.co_ordinate,
      }
    : {};

  return (
    <CardLayout
      title={t("level_details")}
      className="!w-full flex-1 !h-fit !min-h-[200px] "
    >
      {isLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader />
        </div>
      ) : error ? (
        <CardError message={t("feedback_msg.error_fetching")} />
      ) : !data ? (
        <NoContent message={t("feedback_msg.no_data")} />
      ) : (
        <SingleTable
          data={detailsData}
          titleColumnWidth="30%"
          titleColumnStyle={{ fontWeight: "bold" }}
        />
      )}
    </CardLayout>
  );
}

export default LevelDetailTable;
